module.exports = __webpack_public_path__ + "static/media/zombiesMTL-Logo.467fea6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zombiesMTL-Logo.png
// module id = 430
// module chunks = 0